import { CiaoPrologInterface, cp_atm, cp_flt, cp_int, cp_num, cp_query, cp_string, cp_struct, cp_term, QueryResponse } from "./controllers/ciao-prolog-interface";
import { BuilderConfig, InterfaceBuilder } from "./controllers/interface-builder";
export {
    CiaoPrologInterface,
    InterfaceBuilder,
    BuilderConfig,
    cp_atm,
    cp_flt,
    cp_int,
    cp_num,
    cp_query,
    cp_string,
    cp_struct,
    cp_term,
    QueryResponse
}